
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqdrMwbLowam50_GCMoDl755NHWvUNSk_gmcd7ADnZODwMeta } from "/codebuild/output/src2220211587/src/src/pages/faq.vue?macro=true";
import { default as menugqYKqOljBuXsdrs3MwVXdliGBcIqBWkEvXA0euo6OoAMeta } from "/codebuild/output/src2220211587/src/src/pages/menu.vue?macro=true";
import { default as indexqt_45V9W6inzpqAGy_E9yFGj_wjtnZpalf5dBfsr27NQEMeta } from "/codebuild/output/src2220211587/src/src/pages/index.vue?macro=true";
import { default as contactQm8H8amryUT3a8z4cABswhkUJ2z6EHNDfPHd57lRRG8Meta } from "/codebuild/output/src2220211587/src/src/pages/contact.vue?macro=true";
import { default as tutorialNy7_vrFdYSHaouJSn5SJT_FSTJftP4BA7RI1N2d_HN8Meta } from "/codebuild/output/src2220211587/src/src/pages/tutorial.vue?macro=true";
import { default as agreementCIzfsVYIs_8vUXvWBB0m0LOFz0uzJ9tLyEW_T6TvxkAMeta } from "/codebuild/output/src2220211587/src/src/pages/agreement.vue?macro=true";
import { default as about_45passySBHc1Bdzu6CyW8T6uZ7KIaHBzM1OxyG45jDdQwzLusMeta } from "/codebuild/output/src2220211587/src/src/pages/about-pass.vue?macro=true";
import { default as indexiVe_455C812KzPMH9RSUCCMG6Papengh1XeT0C9xawOv8Meta } from "/codebuild/output/src2220211587/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93MfR9YPsoMCMkmqG2HboD9nnXuNtws1lrkBcCkvP88lIMeta } from "/codebuild/output/src2220211587/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance7hR3Ggcjq6JdtpwOSK8PHu9ElsNB5_4545Km9G_45tJPmsQMeta } from "/codebuild/output/src2220211587/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_936EWp1FUmaNroucpkxL7LWH304SDzwyszyGW0LYSiAZ8Meta } from "/codebuild/output/src2220211587/src/src/pages/notice/[id].vue?macro=true";
import { default as indexfBGOGLceTFL21tXsZSe3zHHn6iJ05bX6atdgdhbedroMeta } from "/codebuild/output/src2220211587/src/src/pages/coupon/index.vue?macro=true";
import { default as indexJDEeNaEcgOsIdMWCv33uTVpxQv8RGQu1CNT4QDLSpg0Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/index.vue?macro=true";
import { default as indexPbHvDn_45ZnWOqVANQuyP_VXL2yBqWTrxdhGIruIZfmcoMeta } from "/codebuild/output/src2220211587/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ha4VqsuMxy2IVj9feCl5KE2p8k8dokQNYFvlPPL55KIMeta } from "/codebuild/output/src2220211587/src/src/pages/parking/[id].vue?macro=true";
import { default as indexydRsJTUISzAXkxAjdvAsPLCfJAnZKBw9Bu5cs1SSpawMeta } from "/codebuild/output/src2220211587/src/src/pages/history/index.vue?macro=true";
import { default as indexyQddVXIiRhgfhmJv_3XJC9yhlmZJjvzx2Lb_452_450tcBsMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/index.vue?macro=true";
import { default as indexDFtS5Sn9eE8bZHlNzPxyUEp7HmkEciP31RTzbdTAh_EMeta } from "/codebuild/output/src2220211587/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexJbQuh1Hnh_Kby7blTxEzEApq8GNJNu3jnvaABeF2AeEMeta } from "/codebuild/output/src2220211587/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviPtYSmk57hFjs3JqHXPJWFUkwXvE9_g3n02DMu7WoI3MMeta } from "/codebuild/output/src2220211587/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit7oq6u8FOCVf1ocQxCg4yINNGn5xAvMGfUazYUpefxU8Meta } from "/codebuild/output/src2220211587/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementAQqq_rQrj9APLeOh5IDBhtPRFcVN9JmbWt32SNyOnMUMeta } from "/codebuild/output/src2220211587/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexn6Ltrm4dM_Adp8ZMWrMmPUfkCrAjVCEtkPqIK680ZTEMeta } from "/codebuild/output/src2220211587/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d6u2REZlZO6uhMBa994hQ5z6bXwNCeglHybTmkaHNhFMMeta } from "/codebuild/output/src2220211587/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmyaoLOcVnxz6FSpe5kBKNwaNQhdDO6jY0hQxYZ16OLU4Meta } from "/codebuild/output/src2220211587/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexmeVfhBIbwrfEec0YMTXHrBEgiTINN23ix3VHLzpC_eQMeta } from "/codebuild/output/src2220211587/src/src/pages/card/create/index.vue?macro=true";
import { default as index_45JZ78z6gbaDEXHWs_LtU1wpUPIiJ9jtQFt3zshA4_451gMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_45hF5qrFYSqACJthzt1sNMMRuX18pw2tt2biMVdFmSVoMeta } from "/codebuild/output/src2220211587/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm2FwUzLVc_45uons6uvLF09o4eSPWFK2wHZfqdgymV6d5EMeta } from "/codebuild/output/src2220211587/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeyLEsDXCNlUZLuw_45JocwYVxRt7FEvVVlb8iHegMmVIGMMeta } from "/codebuild/output/src2220211587/src/src/pages/membership/complete.vue?macro=true";
import { default as registeroM0WxIhDy4jdv8CLHVa3cVg4NAdk9z9pt_Ve3rmBCk8Meta } from "/codebuild/output/src2220211587/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_936OHD9mMxB8SqsTwJIz71RvBIuThs0gE_0C_kLa3g0WAMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmZqCXirP2Uva5cRT3_KJrL4cejWfMpV8nqS55k0cR0QEMeta } from "/codebuild/output/src2220211587/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_934QyHwgGPZQNYd8W7_XGb2cJTyzdqnevf9yFY5LNyZgcMeta } from "/codebuild/output/src2220211587/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index2spl64_ADZQ7VpYpokmUoIKD3_45tRIskqSvh6s1KDpBwMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codekIqISuURq_Vo0FbLnnGgB_uER_dwhP26J24kG0eDBugMeta } from "/codebuild/output/src2220211587/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeoe3tDXQc_45VXjI_45_CSflfc6O26r_453sfGTR7tlZVNi5_sMeta } from "/codebuild/output/src2220211587/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeCx5szIUA6TnB9_qPtUofZJji5mz8U1ll8idjefu4z8YMeta } from "/codebuild/output/src2220211587/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register_45vcdqJDMHy2e1_CxAi_45031jXpft7upgf4Fllof_oycoMeta } from "/codebuild/output/src2220211587/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete25eny6M6Z00a33j09zFluAwEUGnlWGhCY61UjSRnYP4Meta } from "/codebuild/output/src2220211587/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexW_45FU4gsbR0kSVuyLyDJVEEmBzXn8rAurSlWtTIW4ffcMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmYhw9ax0mQWlc5IZ4e4FOpHqov6VsSqrL6j2OspQ_45go8Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeuCZ8rQcnnNGAduzs30e4kkIUoQSX15wtqKHHYxdacg8Meta } from "/codebuild/output/src2220211587/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexzBlWjd9eyyQy8a9dAIKQJQ88bPvQ3ERTvpK83WVst6oMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93qpgo2sgn1u7QYvOYfCw7S2n6_45Ilre589N_x_45juJI6J0Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete4hvyxSz_45LEakR2NTB5lJ9vvv3L44SUJKa4H_45SG3f0PkMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias5fhZYWfVkY_t_D1iSHrTaw_45UjT_VAnjlAqIKsSOlr8cMeta } from "/codebuild/output/src2220211587/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplePo3JCzTjOkSFk2pqZUgY161VPu_fmZr2trHUgAsD0NAMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailt_3xEX1tfrirnVb6fcv9V7VzccLI_vZkU0DHjerrUWUMeta } from "/codebuild/output/src2220211587/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmzF_45vRvc2lFFHHaqlp_45fQ28PGuO75h_j9uJIihXM8esEMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentVaWxlwedzCvkT4njr9cL9sa1wqT08GnETZS2ddaxEkoMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmjT1a1Vnfn72CPfRJxHixJdUqJwGOK2PRDFMJYopGV3EMeta } from "/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateu5CQoyWz8zoapogfjBIGfIDO31xoXZCu7_VYpz387TsMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeAAmFN02r7bat4aD_oYK8BROvmlr9ijsYf21zTyZrMzQMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeWbRcUOLWt9fpr7iEAK_JaSX_458CbN1UMPJMnNNT3yoj8Meta } from "/codebuild/output/src2220211587/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordua3lFQvyTVBEGU_455Y1acTXx5hinKQDt_wUbM9I7qWLcMeta } from "/codebuild/output/src2220211587/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasfi6vpRRNRpFp9nZLMOFfl1dlCCAwnY0wtKlOm3hl3MQMeta } from "/codebuild/output/src2220211587/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register2UbmeDanhVZ9TTWLcSFM1P_0tvyHEqszBXBrA7madhEMeta } from "/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeC_8bjFxCud8drFBW7P_xyCAXN38AdbllTpYqNcIpKs4Meta } from "/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index8UVGSB1SW9CQXi6XcuyiR6LWL5PPOq1FhX_DsHKOXKwMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index8Lm2UHN3IZETEM_96EIoTkGktHrzFdAlUFNBiwR_45DaIMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexCscbEWTznzFX2pEixyhPvdVrrn4YnWNxT9mb3LJwO_IMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexP3ycEl0OryjgQzrBnXrRAVLFYE2CRx4cVzApAE0_JMYMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateNrX_45JQGabM_9CR_lzYwFHL0yq3Yk_45y_WsgTtm_DYOtEMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete584FRieEXRKLp0IC66HwXzk5qhNcqt5EiAJ7O5j0jyYMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirml4cc6OKTxEPzaRTh88qROQ7EOzjyVrMQQL4_45pI5ed9MMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexDfTVJ7S42VG5wxGxL0lmd4tF_1hlMVADNh3x1hjH1bMMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeoN6_45C4F_45y9T9Ld4D3ndYF3pOpLfq581uv4G7wPZjk60Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateIYS7GseySKcNeaEoQzNGMJL4rKSwsjfOMkHH_kz4QeQMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexxY3HdMRJTO2fkqBRMFw4etnUFLiwjxMk7ck5Y3B9O4sMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index_456uKvmFmpSXpEKaTdfUB3FgJhgBInuOpZDoefIUQuYwMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completewmO6FQY7nABd2Zp89CCmlv5SHwMNeB9gz7GOCUFK4noMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexfAmnFEj36iqmcyDyBqkFIaacWBAiz7_45MYyen3VMrOacMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codev_45PMNfEcHeJ9DQS_M0BiXRDiufsgnSo3TJ8C5rtWSIIMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexWnx7ksJjEzGSCoAe177_450XzctQxTv4AhCBYTd9J3kl8Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexj87tHz3eQZAdcDPnzGhGcDkYDghf35N87OvXSB_S4uAMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexhPmZD_45RC_PIvOHkWBhl98oab7VzGokfND8xYNMYPXyUMeta } from "/codebuild/output/src2220211587/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update3CfTL9O_3k04Ef0xEgQGdhkEzXtZI4IVJKRT2Z9H8G4Meta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmvbBSqegH5Ri9VsQ6ER7abOksHIXZ5O8xKaoPH3frN2sMeta } from "/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menugqYKqOljBuXsdrs3MwVXdliGBcIqBWkEvXA0euo6OoAMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexqt_45V9W6inzpqAGy_E9yFGj_wjtnZpalf5dBfsr27NQEMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexfBGOGLceTFL21tXsZSe3zHHn6iJ05bX6atdgdhbedroMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexydRsJTUISzAXkxAjdvAsPLCfJAnZKBw9Bu5cs1SSpawMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexDFtS5Sn9eE8bZHlNzPxyUEp7HmkEciP31RTzbdTAh_EMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexJbQuh1Hnh_Kby7blTxEzEApq8GNJNu3jnvaABeF2AeEMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexmeVfhBIbwrfEec0YMTXHrBEgiTINN23ix3VHLzpC_eQMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_45hF5qrFYSqACJthzt1sNMMRuX18pw2tt2biMVdFmSVoMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm2FwUzLVc_45uons6uvLF09o4eSPWFK2wHZfqdgymV6d5EMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeyLEsDXCNlUZLuw_45JocwYVxRt7FEvVVlb8iHegMmVIGMMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeroM0WxIhDy4jdv8CLHVa3cVg4NAdk9z9pt_Ve3rmBCk8Meta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmZqCXirP2Uva5cRT3_KJrL4cejWfMpV8nqS55k0cR0QEMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codekIqISuURq_Vo0FbLnnGgB_uER_dwhP26J24kG0eDBugMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeoe3tDXQc_45VXjI_45_CSflfc6O26r_453sfGTR7tlZVNi5_sMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeCx5szIUA6TnB9_qPtUofZJji5mz8U1ll8idjefu4z8YMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register_45vcdqJDMHy2e1_CxAi_45031jXpft7upgf4Fllof_oycoMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmYhw9ax0mQWlc5IZ4e4FOpHqov6VsSqrL6j2OspQ_45go8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeuCZ8rQcnnNGAduzs30e4kkIUoQSX15wtqKHHYxdacg8Meta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexzBlWjd9eyyQy8a9dAIKQJQ88bPvQ3ERTvpK83WVst6oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete4hvyxSz_45LEakR2NTB5lJ9vvv3L44SUJKa4H_45SG3f0PkMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplePo3JCzTjOkSFk2pqZUgY161VPu_fmZr2trHUgAsD0NAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailt_3xEX1tfrirnVb6fcv9V7VzccLI_vZkU0DHjerrUWUMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmzF_45vRvc2lFFHHaqlp_45fQ28PGuO75h_j9uJIihXM8esEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentVaWxlwedzCvkT4njr9cL9sa1wqT08GnETZS2ddaxEkoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmjT1a1Vnfn72CPfRJxHixJdUqJwGOK2PRDFMJYopGV3EMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeAAmFN02r7bat4aD_oYK8BROvmlr9ijsYf21zTyZrMzQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeWbRcUOLWt9fpr7iEAK_JaSX_458CbN1UMPJMnNNT3yoj8Meta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordua3lFQvyTVBEGU_455Y1acTXx5hinKQDt_wUbM9I7qWLcMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register2UbmeDanhVZ9TTWLcSFM1P_0tvyHEqszBXBrA7madhEMeta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeC_8bjFxCud8drFBW7P_xyCAXN38AdbllTpYqNcIpKs4Meta || {},
    component: () => import("/codebuild/output/src2220211587/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2220211587/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]